module.exports = __webpack_public_path__ + "img/whiteboard_off.31cce6a3.png";